import { isMac } from 'lib/helpers';

const KEY_CODE_S = 83;

/**
 * @param {React.KeyboardEvent} evt
 */
export function isSaveAction(evt) {
	if (isMac) {
		return evt.metaKey && !evt.shiftKey && !evt.ctrlKey && !evt.altKey && evt.keyCode === KEY_CODE_S;
	}
	else {
		return !evt.metaKey && !evt.shiftKey && evt.ctrlKey && !evt.altKey && evt.keyCode === KEY_CODE_S;
	}
}



// WEBPACK FOOTER //
// ./lib/helpers/isSaveAction.js